var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "delivery-info-form",
      class: { "view-form-disabled": !_vm.editable },
    },
    [
      _c(
        "el-form",
        {
          ref: "deliveryForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            disabled: !_vm.editable,
            "label-width": "110px",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "view-form-disabled",
                      attrs: { label: "客户类型：", prop: "customer_type" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.form.customer_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customer_type", $$v)
                            },
                            expression: "form.customer_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(
                              "一类客户[政府机构/事业单位/国有控股、国有独资企业]"
                            ),
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("二类客户[国有参股企业/实缴资本>1000万)]"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("三类客户[除一类、二类之外的企业]"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "12px" },
                      attrs: { label: "折扣：", prop: "discount" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.discount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "discount", $$v)
                          },
                          expression: "form.discount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "服务成本：", prop: "company_cost" } },
                    [
                      _c(
                        "div",
                        { staticClass: "input-with-tip" },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.form.company_cost,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "company_cost", $$v)
                                },
                                expression: "form.company_cost",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  "销售业绩以及佣金基数=售卡总金额-服务成本",
                                placement: "top",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline tip-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠券成本：", prop: "service_cost" } },
                    [
                      _c(
                        "div",
                        { staticClass: "input-with-tip" },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.form.service_cost,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "service_cost", $$v)
                                },
                                expression: "form.service_cost",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  "开票金额=应收金额（售卡总金额+优惠券成本）",
                                placement: "top",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline tip-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "结算方式：", prop: "settlement_type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.settlement_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "settlement_type", $$v)
                            },
                            expression: "form.settlement_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("按售卡结算"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("按消费结算"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "偏差金额：", prop: "diff_money" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.diff_money,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "diff_money", $$v)
                          },
                          expression: "form.diff_money",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "佣金核算方式：",
                        prop: "commission_type",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.commission_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "commission_type", $$v)
                            },
                            expression: "form.commission_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("自动核算"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("人工未核算"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("人工已核算"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "偏差原因：",
                                prop: "diff_remark",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "calc(100% - 10px)" },
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.diff_remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "diff_remark", $$v)
                                  },
                                  expression: "form.diff_remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "交付负责人：", prop: "the_loser_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.onLeaderChange },
                          model: {
                            value: _vm.form.the_loser_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "the_loser_id", $$v)
                            },
                            expression: "form.the_loser_id",
                          },
                        },
                        _vm._l(_vm.sellUserList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.form.the_loser_id
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "成本率目标：",
                            prop: "target_cost_rate",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.form.target_cost_rate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "target_cost_rate", $$v)
                                },
                                expression: "form.target_cost_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showConfirm && _vm.editable
        ? _c(
            "div",
            { staticClass: "delivery-confirm" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.confirmLoading },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }